import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { CreateVoiceCallListService, GetVoiceCallListDetailService } from '../../../services/admin/VoiceCallListServices';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import toast from 'react-hot-toast';
import { DatePicker, Modal } from 'antd';
import { TextInput } from '../../../components/input';
import ErrorComponent from '../../../components/ErrorComponent';
import dayjs from "dayjs";
import { MdCheckBoxOutlineBlank,MdCheckBox } from "react-icons/md";


function VoiceCallListDetail() {

  const navigator = useNavigate()

  const {state} = useLocation()

  console.log("state",state)

  const [data,setdata] = useState({})
  const [stage,setstage] = useState('FAILED')
  const [callModal, setcallModal] = useState(false)

  const [selecteddataList, setselecteddataList] = useState([])

  const [voiceCall,setvoiceCall] = useState({campaign_type:'',scheduled_at:'',scheduled_at_1:'',cli_number:'',campaign_name:'',voice_file_id:''})
  const [voiceCallErr,setvoiceCallErr] = useState({campaign_type:'',scheduled_at:'',scheduled_at_1:'',cli_number:'',campaign_name:'',voice_file_id:''})



// FollowUp (3 Days)


  useEffect(() => {
    getdata()
  }, [state])

  async function getdata() {
    const response = await GetVoiceCallListDetailService(state?._id)
    setdata(response?.data?.datas?.length > 0 ? response?.data?.datas[0] : [])
  }

  let statusArr = ['FAILED','ANSWERED','ANSWERED AND PRESSED 1']

  const filteredData =  data?.targeted_customer?.filter((f) => f?.status === stage)
  // const filteredData = []

  async function downloadFailed() {

   let datas = filteredData
   const headers = ["S.No", "Full Name", "Mobile", "Status"];
   const rows = datas.map((d, i) => [i + 1, d.customer_details?.name, d.customer_details?.mobile,d?.status]);

    const csv =
      headers.join(",") + "\n" +
      rows.map(r => r.join(",")).join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "custom.csv";
    a.click();
    }


     function selectdatas(v){
      if(selecteddataList?.includes(v)){
        setselecteddataList(selecteddataList.filter(f=>f!==v))
      }else{
        if(selecteddataList.length < 150){
          setselecteddataList([...selecteddataList,v])
        }else{
          toast.error("Maximum Selected Reached : 150")
        }
      }
    }

      async function submitCall(){
    let send_data = {...voiceCall}
    send_data['targeted_customer'] = selecteddataList?.map((s)=>({customer:s,status:'PENDING'}))
    await CreateVoiceCallListService(send_data)
    toast.success("Voice Call Created Successfully!")
    setvoiceCall({campaign_type:'',scheduled_at:'',scheduled_at_1:'',cli_number:'',campaign_name:'',voice_file_id:''})
    setvoiceCallErr({campaign_type:'',scheduled_at:'',scheduled_at_1:'',cli_number:'',campaign_name:'',voice_file_id:''})
    setcallModal(false)
    setselecteddataList([])
  }

  const validateSchedule = (date) => {
        const selected = dayjs(date);
        const now = dayjs();
  
        if (selected.isBefore(now)) {
          return "You cannot select a past date or time.";
        }
  
        const hour = selected.hour();
  
        if (hour < 7 || hour > 19) {
          return "Time must be between 7:00 AM and 7:00 PM.";
        }
  
        return ""; 
    };

  function handlechange(e){
    let {name,value} = e.target
    setvoiceCall({...voiceCall,[name]:value})
    setvoiceCallErr({...voiceCallErr,[name]:''})
  }  

    function selectOption(v) {
      if (v === '3') {
        setselecteddataList([]);
      }

      if (v === '1') {
        const allIds = filteredData?.map(d => d?.customer_details?._id) || [];
        const oldData = [...selecteddataList, ...allIds];
        const uniqueData = Array.from(new Set(oldData)).slice(0, 150);
        setselecteddataList(uniqueData);
      }

      if (v === '2') {
        const currentData = filteredData?.map(d => d?.customer_details?._id) || [];
        const updatedData = selecteddataList.filter(id => !currentData.includes(id));
        setselecteddataList(updatedData);
      }
    }
    
  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

       <Modal
              keepMounted
              open={callModal}
              onClose={() => setcallModal(false)}
              width={300}
              footer={false}
              closable={false}
      
            >
              <div >
                <h6 className="font-bold text-[15px] mb-2 w-full">Create VoiceCall</h6>
                <h6 className='bg-slate-100 text-[12px] p-1.5 font-[400]'>Be sure while creating the voice call once created will not be deelted in track</h6>
                
                <TextInput 
                  label={'Campaign Type'}  
                  variant="standard"
                  name="campaign_type"
                  type="text"
                  error={voiceCallErr.campaign_type}
                  value={voiceCall.campaign_type}
                  handlechange={handlechange}
                  placeholder="Enter your days"
                  InputLabelProps={{
                      style: { color: '#fff', }, 
                  }}/>
      
                  <h6 className='text-[11px] font-[400] my-1'>Scheduled At</h6>
                  <DatePicker 
                  className='border border-slate-300 rounded-[0px] w-full'
                  showTime={{ format: 'HH:mm:ss' }}
                  format="YYYY-MM-DD HH:mm:ss"
                  label={'Scheduled At'}  
                  variant="standard"
                  name="scheduled_at"
                  error={voiceCallErr.scheduled_at}
                  value={voiceCall.scheduled_at_1}
                  onChange={(e,e1)=>{
                    const error = validateSchedule(e);
                    if (error) {
                        setvoiceCallErr({ ...voiceCallErr, scheduled_at: error });
                        setvoiceCall({ ...voiceCall, scheduled_at: "", scheduled_at_1: null });
                        return;
                    }
                    setvoiceCall({...voiceCall,scheduled_at:e1,scheduled_at_1:e});
                    setvoiceCallErr({...voiceCallErr,scheduled_at:'',scheduled_at_1:''})
                  }}
                  placeholder=""
                  InputLabelProps={{
                      style: { color: '#fff', }, 
                  }}/>
      
                  <ErrorComponent error={voiceCallErr.scheduled_at} />
      
                  
      
      
                  <TextInput 
                  label={'Cli Number'}  
                  variant="standard"
                  name="cli_number"
                  type="text"
                  error={voiceCallErr.cli_number}
                  value={voiceCall.cli_number}
                  handlechange={handlechange}
                  placeholder="Enter your days"
                  InputLabelProps={{
                      style: { color: '#fff', }, 
                  }}/>
      
      
                  <TextInput 
                  label={'Campaign Name'}  
                  variant="standard"
                  name="campaign_name"
                  type="text"
                  error={voiceCallErr.campaign_name}
                  value={voiceCall.campaign_name}
                  handlechange={handlechange}
                  placeholder="Enter your days"
                  InputLabelProps={{
                      style: { color: '#fff', }, 
                  }}/>
      
                  <TextInput 
                  label={'Voice File Id'}  
                  variant="standard"
                  name="voice_file_id"
                  type="text"
                  error={voiceCallErr.voice_file_id}
                  value={voiceCall.voice_file_id}
                  handlechange={handlechange}
                  placeholder="Enter your days"
                  InputLabelProps={{
                      style: { color: '#fff', }, 
                  }}/>
      
               
                <div className='flex justify-end mt-3 '>
                  <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setcallModal(false)} />
                  <div className='ml-2'>
                    <ButtonFilledAutoWidth btnName={'Save'} onClick={() => submitCall()} />
                  </div>
                </div>
              </div>
            </Modal>

   

      <div className='md:flex'>
        <div>
          <SettingsMenu  />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center py-2 border-b justify-between pb-3'>
            <div className='flex w-[100%] items-center  justify-between'>
            <h6 className='font-[800] text-[13px]'>VoiceCall Target Customer ({data?.targeted_customer?.length})</h6>
           
           <div className='flex items-center'>
           {selecteddataList?.length > 0 && <ButtonOutlinedAutoWidth btnName="Send VoiceCall" onClick={() => setcallModal(!callModal)} />}
            <h6 onClick={downloadFailed} className='bg-slate-100 ml-2 cursor-pointer border rounded font-[600] w-max border-slate-300 text-[12px] px-1 py-1 '>Download List</h6>
           </div>

            </div>
          
          </div>


         
          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {statusArr?.map((s)=>(
                <h6 onClick={()=>{setstage(s)}} className={`font-[600] ${stage === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
            </div>

            {filteredData?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

              

            {filteredData?.length > 0 && <> 
            

            <div className='w-[100%] overflow-hidden'>

              <div className='flex cursor-pointer items-center font-[600] mt-2'>
                <h6 onClick={()=>selectOption('1')} className='text-[12px] mr-1 bg-slate-100 p-1'>Select All</h6>
                <h6 onClick={()=>selectOption('2')} className='text-[12px] mr-1 bg-slate-100 p-1'>De Select All</h6>
                <h6 onClick={()=>selectOption('3')} className='text-[12px] mr-1 bg-slate-100 p-1'>Remove All</h6>
                {selecteddataList?.length > 0 && <h6 className='text-[11px]'>Data Selected ({selecteddataList?.length})</h6>}
              </div>

            
              {filteredData?.length > 0 &&
                <div className='md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-max md:w-[100%]  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Select</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Info</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Status</h6>
                
                  </div>
                  {filteredData?.map((d, i) => (
                    <div className='flex w-max md:w-[100%] text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>{i + 1}</h6>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>
                        {selecteddataList?.includes(d?.customer_details?._id) ? <MdCheckBox size={20} onClick={()=>selectdatas(d?.customer_details?._id)} className='text-[#de9f19] cursor-pointer' /> : <MdCheckBoxOutlineBlank size={20} onClick={()=>selectdatas(d?.customer_details?._id)} className='text-slate-200 cursor-pointer' />}
                      </h6> 
                      
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  md:min-w-[180px] md:w-[180px] px-2 py-1 border-r'>
                        <span className='font-bold'>{d?.customer_details?.name}</span>
                      
                      </h6>
                      <h6 className=' text-[12px] break-word min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px] px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{d?.customer_details?.mobile}</span><br></br>
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[500] border-r'>
                       {d?.status}
                      </h6>
                     
                      <h6 className='flex   break-word  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[20px] px-2 py-1 font-[500] border-r'>{d?.targeted_customer?.customer?.remarks}</h6>
                     
                    </div>))}
                </div>}
            </div>
            </>}

          </div>

        </div>
      </div>
    </div>
  )
}

export default VoiceCallListDetail